import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { listSagas, cancelSaga, listPollers } from '../services/activityApi'

const SAGA_ACTIVE = new Set(['running', 'compensating'])

// Poll the saga list. Faster cadence while something is active; the same query
// key backs both the Activity page and the nav badge (react-query dedups).
export function useActivitySagas() {
  return useQuery({
    queryKey: ['sagas', 'activity'],
    queryFn: () => listSagas({ limit: 50 }),
    refetchInterval: (q) => {
      const sagas = q.state.data?.sagas ?? []
      return sagas.some((s) => SAGA_ACTIVE.has(s.status)) ? 2000 : 10000
    },
    select: (d) => d.sagas ?? [],
  })
}

// Count of in-flight sagas — for the nav badge. Shares the cache above.
export function useRunningSagaCount() {
  const q = useActivitySagas()
  return (q.data ?? []).filter((s) => SAGA_ACTIVE.has(s.status)).length
}

// Pollers change slowly (hours) — a lazy poll keeps the next-run countdown fresh.
export function usePollers() {
  return useQuery({
    queryKey: ['pollers'],
    queryFn: listPollers,
    refetchInterval: 30000,
    select: (d) => d.pollers ?? [],
  })
}

export function useCancelSaga() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: cancelSaga,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sagas', 'activity'] }),
  })
}
